export default "/images/sonderjysk.png?59c08a3ab928d87ae3781938a7b2cfe2";